import { BCMSDate, BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/ChatPage";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @function CaptureChatSelectLanguage
 * @return {React.Component}
 * @exported true
 * @description Capture component for "008_Chat_SelectLanguage".
 */
export default function CaptureChatSelectLanguage(props) {
    const { branding } = useModel();
    const options = branding.options || {};
    const chatVersion = options.chat_version_abi22 === "undefined" ? "Chat Box" : options.chat_version_abi22;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], true)        
        .submit();

    if(chatVersion === "Full Screen") {
        const message = `This capture is only shown when branding option "Chat Version" is set to "Chat Box".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ChatPage ui={ ui } />
}